var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.status == 'p')?_c('b',{class:[_vm.getValueTextClass()],staticStyle:{"font-size":"16px"}},[_vm._v(_vm._s(_vm._f("decimal")(_vm.value)))]):_c('s',{class:'text-muted'},[_vm._v(_vm._s(_vm._f("decimal")(_vm.value)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }